import type { FilterTag, ProposalListItem } from '@/lib/proposals/core/types';

/**
 * Filter tags that represent CRM-only operations.
 * Proposals whose tags are entirely within this set are grouped
 * under the "CRM UPDATES" tier instead of HIGH/MEDIUM priority.
 */
export const CRM_ONLY_TAGS = new Set<FilterTag>([
  'pipeline_update',
  'crm_create',
  'crm_delete',
  'crm_associate',
  'crm_merge',
]);

/**
 * Tags that are metadata qualifiers, not action-type indicators.
 * These are ignored when classifying proposals.
 */
const IGNORED_TAGS = new Set(['demo', 'property_update']);

/**
 * Returns true when every action-type filter tag on the proposal is a CRM operation.
 * Proposals with no tags return false (they are uncategorised, not CRM-only).
 * Metadata tags (demo, property_update) are ignored in the classification.
 */
export function isCrmOnlyProposal(proposal: ProposalListItem): boolean {
  const actionTags = proposal.filter_tags.filter(tag => !IGNORED_TAGS.has(tag));
  if (actionTags.length === 0) {
    return false;
  }
  return actionTags.every(tag => CRM_ONLY_TAGS.has(tag as FilterTag));
}
